import React from "react";
import { useHistory } from "react-router-dom";
import applicationComander from "../../../store/commanders/application.comander";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLongArrowAltLeft,
  faCircleUser,
} from "@fortawesome/free-solid-svg-icons";
import { useForm } from "@mantine/form";
import { Box, Button, Group, Space, Text, TextInput } from "@mantine/core";
import { validateEmail } from "../../../helpers/form.validators";
import { URL_PATHS } from "../../../consts/url.paths.consts";
import { Icon } from "@fortawesome/fontawesome-svg-core";

const ForgotPasswordPage = (props) => {
  const history = useHistory();
  const existsEmailValue =
    props &&
    props.location &&
    props.location.state &&
    props.location.state.email
      ? props.location.state.email
      : null;

  const form = useForm({
    initialValues: {
      email: existsEmailValue,
    },

    validate: {
      email: validateEmail,
    },
  });

  const onSubmit = (data) => {
    applicationComander.cmd_forgot_password(data.email);
  };
  return (
    <div>
      <div className="auth-container-box">
        <Box className="auth-single-form">
          <FontAwesomeIcon
            icon={faCircleUser as Icon}
            size={"5x"}
            className="auth-icon"
          />
          <Text className="auth-title" style={{fontSize: '2rem'}}>Reset Your Password</Text>
          <Text className="auth-description">
            We'll send you a reset code.
          </Text>
          <form
            onSubmit={form.onSubmit((values) => onSubmit(values))}
            className="u-w-100"
          >
            <TextInput
              required
              label="Email"
              placeholder="your@email.com"
              className="u-w-100"
              {...form.getInputProps("email")}
            />
            <Space h="md" />
            <Group mt="lg" mb="sm">
              <Button size="lg" type="submit" className="u-w-100 auth-submit-button">
                SEND CODE
              </Button>
              <Button 
                size="lg" 
                variant="outline" 
                className="u-w-100 mobile-auth-button"
                onClick={() => history.push(URL_PATHS.LOGIN)}
              >
                BACK TO LOGIN
              </Button>
            </Group>
            <Space h={"sm"}></Space>
            <Text
              size="sm"
              align="left"
              className="auth-link"
              onClick={() => history.push(URL_PATHS.LOGIN)}
            >
              <FontAwesomeIcon icon={faLongArrowAltLeft as Icon} />
              <span className="u-ml-sm">Back to Log In</span>
            </Text>
          </form>
        </Box>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
